module.exports = __webpack_public_path__ + "static/media/icon_eye_on.65034010.svg";